import { Component, inject, Input,
    ChangeDetectionStrategy
} from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { KeyValuePair } from 'src/modules/utils/shared/key-value-pair.model';
import { Project } from '../../netgen/Project';
import { ProjectCustomFieldDefinition } from '../../netgen/ProjectCustomFieldDefinition';
import { ProjectStatistics } from '../../netgen/ProjectStatistics';
import { ProjectPlanningService } from '../../services/project-planning.service';
import { ProjectDocumentsComponent } from '../project-documents/project-documents.component';
import { Arrays } from 'src/modules/utils/shared/arrays';

@Component({
  selector: 'app-project-information',
  standalone: false,
  templateUrl: './project-information.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './project-information.component.scss'
})
export class ProjectInformationComponent extends ComponentView {

    service = inject(ProjectPlanningService);
    
    @Input()
    detailed = false;
    @Input()
    stats: ProjectStatistics;   
    _project: Project;
    
    fieldDefs: ProjectCustomFieldDefinition[] = [];
    customFields: KeyValuePair<string, string>[] = [];
    createdBy = "";    
    contactPerson = "";

    async initParams(): Promise<boolean> {
        this.fieldDefs = await this.service.getProjectCustomFieldDefinitions();
        this.updateCustomFields();
        return true;
    }

    @Input()
    set project(value: Project) {
        this._project = value;
        this.updateCustomFields();
        this.createdBy = this.service.getUserShortNameByUserName(this._project.createdBy, true);
        this.contactPerson = this.service.getUserShortName(this._project.contactPersonId);
    }

    updateCustomFields(): void {        
        if (this._project != null) {
            this._project.customFields = Arrays.sortBy(this._project.customFields, cf => this.fieldDefs.find(fd => fd.id == cf.fieldDefinitionId)?.order ?? 0);
            this.customFields = this._project.customFields.map(cf => new KeyValuePair<string, string>(this.fieldDefs.find(fd => fd.id == cf.fieldDefinitionId)?.title ?? "???", cf.value));
        }
        else {
            this.customFields = [];
        }
    }
    
    async openDocuments(): Promise<void> {
        await this.app.dialog.component(ProjectDocumentsComponent, this.app.t("ProjectPlanning.projectDocuments"), { width: "100%" }, { projectNumber: this._project.projectNumber });
    }
    
}
